import { combineEpics } from 'redux-observable';

import nolListEpic from './list/epics';
import nolDetailEpic from './detail/epics';

export default combineEpics(nolListEpic, nolDetailEpic);
